<template>
  <div
    id="app"
    :style="{
      paddingTop: meta.HeaderTab ? '180px' : !meta.HeaderBox ? '140px' : '0px'
    }"
    :class="[minWidthFlag && 'AppBox']"
  >
    <Hearder v-if="sidebarFlag" @heardeChang="heardeChang" />
    <router-view ref="myRefs" class="content" />
    <Footer v-if="meta.showFooter" />
    <Login ref="loginRef" />
    <div
      v-if="sidebarFlag"
      class="Selection_app_bar"
      @mouseenter="mouseHove(true)"
      @mouseleave="mouseHove(false)"
    >
      <div
        class="app_bar_item"
        v-for="(item, index) in list"
        :key="index"
        @click="BarItemClick(index)"
      >
        <img
          :src="MouseHoveFlag ? item.Icon : item.iconAtive"
          class="app_bar_item_img"
          alt=""
        />
        <span
          :class="['app_bar_item_name', MouseHoveFlag && 'item_name_ative']"
          >{{ item.Titles }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Footer from '@/components/Footer.vue'
import Hearder from '@/components/Heardes.vue'
import Login from '@/components/Login.vue'
export default {
  components: {
    Hearder,
    Footer,
    Login
  },
  data() {
    return {
      MouseHoveFlag: false,
      // 是否显示侧边栏
      sidebarFlag: false,
      list: [
        {
          Titles: '购物车',
          Icon: require('@/assets/images/order/app_bar_frame.png'),
          iconAtive: require('@/assets/images/order/app_bar_frame04.png')
        },
        {
          Titles: '联系客服',
          Icon: require('@/assets/images/order/app_bar_frame01.png'),
          iconAtive: require('@/assets/images/order/app_bar_frame05.png')
        },
        {
          Titles: '我的订单',
          Icon: require('@/assets/images/order/app_bar_frame02.png'),
          iconAtive: require('@/assets/images/order/app_bar_frame06.png')
        },
        {
          Titles: '返回顶部',
          Icon: require('@/assets/images/order/app_bar_frame03.png'),
          iconAtive: require('@/assets/images/order/app_bar_frame07.png')
        }
      ],
      minWidthFlag: true
    }
  },
  computed: {
    meta() {
      return this.$route.meta
    }
  },
  watch: {
    $route(to) {
      if (to.fullPath.includes('Transfer') || to.fullPath.includes('default')) {
        this.sidebarFlag = false
      } else {
        this.sidebarFlag = true
      }
      if (to.fullPath.includes('default')) {
        this.minWidthFlag = false
      } else {
        this.minWidthFlag = true
      }
    }
  },
  mounted() {
    Vue.prototype.$login = this.$refs.loginRef
  },
  methods: {
    heardeChang(data) {
      if (data.path === this.$route.path) {
        this.$refs.myRefs.StartFun()
      }
    },
    mouseHove(Flag) {
      this.MouseHoveFlag = Flag
    },
    BarItemClick(index) {
      if (index === 0) {
        this.$router.push({
          path: '/shopPing/Cart'
        })
      } else if (index === 1) {
        console.log('跳转到客服')
      } else if (index === 2) {
        this.$router.push({
          path: '/my',
          query: { index: 3 }
        })
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // 平滑滚动
        })
      }
    }
  }
}
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #000;
}
.content {
  flex: 1;
}
div {
  box-sizing: border-box;
}
ol,
ul {
  padding: 0px 0px;
  margin: 0px 0px;
}
li {
  list-style: none;
}
div::-webkit-scrollbar-thumb {
  background: linear-gradient(45deg, #ff6b6b, #ff9c6b); /* 滚动条滑块渐变色 */
  border-radius: 10px; /* 滚动条滑块圆角 */
  border: 2px solid #f1f1f1; /* 滚动条滑块边框 */
}
</style>
<style lang="less" scoped>
.AppBox {
  min-width: 1400px;
}
.Selection_app_bar {
  width: 64px;
  height: 220px;
  background: #ffffff;
  position: fixed;
  right: 0;
  bottom: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0px;
  border-radius: 4px 0px 0px 4px;
  z-index: 2;
  cursor: pointer;
  .app_bar_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .app_bar_item_img {
      width: 20px;
      height: 20px;
      margin-bottom: 4px;
    }
    .app_bar_item_name {
      color: #666666;
      font-size: 10px;
      font-weight: 400;
    }
    .item_name_ative {
      color: #16ad4a;
    }
  }
}
</style>
